<script setup lang="ts">
type ColorType = {
  hex: string
}

const props = defineProps<{
  color?: ColorType
  bgColor?: ColorType
}>()

const style = computed(() => {
  const styles = []

  if (props.color?.hex) styles.push(`color: ${props.color.hex}`)
  if (props.bgColor?.hex) styles.push(`background: ${props.bgColor.hex}`)

  return styles
})
</script>

<template>
  <span :style="style">
    <slot />
  </span>
</template>
